"use client";

import { useRecoilValue } from "recoil";

import Modal from "components/Modal";
import { useApplicationModal } from "hooks/useApplicationModal";
import { applicationModalStore } from "store/applicationModalStore";

const ApplicationAbstractModal = () => {
  const data = useRecoilValue(applicationModalStore);
  const { closeApplicationModal } = useApplicationModal();

  return (
    <Modal onClose={closeApplicationModal} isOpen={data.modalState === "open"}>
      {data.component}
    </Modal>
  );
};

export default ApplicationAbstractModal;
